import React, { useState, useEffect, useCallback } from "react";
// import { connect, useDispatch } from "react-redux";
import { Grid } from "semantic-ui-react";
import QuoteDetailedStatus from "./QuoteDetailedStatus";
import QuoteDetailedManPack from "./QuoteDetailedManPack";
import QuoteDetailedClonePack from "./QuoteDetailedClonePack";
import QuoteDetailedLoadHoliday from "./QuoteDetailedLoadHoliday";
import QuoteDetailedPackages from "./QuoteDetailedPackages";
import { getQuotes, getLeadsData, getUsers, getAuthUser, updateQuotePackageOrder } from "../quoteActions";
import ErrorBoundary from "../../../app/layout/ErrorBoundary";

import firebase from "../../../app/config/firebase";
import { useSelector } from "react-redux";
const firestore = firebase.firestore();

export default function QuoteDetailedPage(props) {
    let quoteId = props.match.params.id;
    const [quote, setQuote] = useState([]);
    const [quotePackages, setQuotePackages] = useState([]);
    // const [quote_templates, setQuote_templates] = useState([]);
    const [lead, setLeads] = useState([]);
    const [consultant, setConsultant] = useState([]);
    const [client, setClient] = useState([]);
    const [isAuth, setIsAuth] = useState(false);

    const { currentUserProfile } = useSelector((state) => state.profile);
    console.log("Current ----quote--edit-- profile:", currentUserProfile);

    const getPackageSortValue = (pkg) => {
        if (!pkg) return 0;
        if (typeof pkg.sort_order === "number") return pkg.sort_order;
        if (pkg.createDate?.seconds) return pkg.createDate.seconds * 1000;
        if (pkg.createDate?.toDate) return pkg.createDate.toDate().getTime();
        return 0;
    };

    const reorderPackages = useCallback(
        async (nextList) => {
            if (!nextList || nextList.length === 0) return;
            setQuotePackages(nextList);
            try {
                await updateQuotePackageOrder(quoteId, nextList);
            } catch (error) {
                console.log(error);
            }
        },
        [quoteId]
    );

    // make wrapper function to give child
    // const wrapperSetParentState = useCallback(
    //     (val) => {
    //         setQuotePackages(val);
    //     },
    //     [setQuotePackages]
    // );

    useEffect(() => {
        const packagesCacheKey = `quote_packages_cache_v1:${quoteId}`;
        try {
            const cached = JSON.parse(sessionStorage.getItem(packagesCacheKey));
            if (cached && Array.isArray(cached.data)) {
                setQuotePackages(cached.data);
            }
        } catch (error) {
            // ignore cache errors
        }

        const unsubscribe = firestore
            .collection("quotes")
            .doc(quoteId)
            .onSnapshot((doc) => {
                let newClient = doc.data();
                newClient.id = doc.id;

                setQuote(newClient);

                if (newClient.clientId) {

                    firestore.collection("clients").doc(newClient.clientId).onSnapshot((doc2) => {
                        setClient(doc2.data())
                    })
                }


                const leadId = newClient?.leadId || newClient?.id;
                getLeadsData(leadId).then(
                    (res) => {
                        if (res.exists) {
                            let appObj = { ...res.data(), ["id"]: `${res.id}` };
                            setLeads(appObj);
                            const assignedUserUid = appObj?.userUid || newClient?.userUid;
                            if (assignedUserUid) {
                                getUsers(assignedUserUid).then(
                                    (userRes) => {
                                        if (userRes.exists) {
                                            let userObj = { ...userRes.data(), ["id"]: `${userRes.id}` };
                                            setConsultant(userObj);
                                        }
                                    },
                                    (err) => {
                                        console.log(err);
                                    }
                                );
                            }
                            return;
                        }

                        if (newClient?.userUid) {
                            getUsers(newClient.userUid).then(
                                (userRes) => {
                                    if (userRes.exists) {
                                        let userObj = { ...userRes.data(), ["id"]: `${userRes.id}` };
                                        setConsultant(userObj);
                                    }
                                },
                                (err) => {
                                    console.log(err);
                                }
                            );
                        }
                    },
                    (err) => {
                        console.log(err);
                        if (newClient?.userUid) {
                            getUsers(newClient.userUid).then(
                                (userRes) => {
                                    if (userRes.exists) {
                                        let userObj = { ...userRes.data(), ["id"]: `${userRes.id}` };
                                        setConsultant(userObj);
                                    }
                                },
                                (userErr) => {
                                    console.log(userErr);
                                }
                            );
                        }
                    }
                );
            });

        // getQuotes(quoteId).then(
        //     (res) => {
        //         if (res.exists) {
        //             let appObj = { ...res.data(), ["id"]: `${res.id}` };
        //             setQuote(appObj);
        //             getLeadsData(res.data().leadId).then(
        //                 (res) => {
        //                     if (res.exists) {
        //                         let appObj = { ...res.data(), ["id"]: `${res.id}` };
        //                         setLeads(appObj);
        //                     }
        //                 },
        //                 (err) => {
        //                     console.log(err);
        //                 }
        //             );
        //             getUsers(appObj.userUid).then(
        //                 (res) => {
        //                     if (res.exists) {
        //                         let appObj = { ...res.data(), ["id"]: `${res.id}` };
        //                         setConsultant(appObj);
        //                     }
        //                 },
        //                 (err) => {
        //                     console.log(err);
        //                 }
        //             );
        //         }
        //     },
        //     (err) => {
        //         console.log(err);
        //     }
        // );

        const unsubscribe2 = firestore
            .collection("quotes")
            .doc(quoteId)
            .collection("packages")
            .onSnapshot((snapshot) => {
                let list = [];

                snapshot.docs.forEach((doc) => {
                    if (doc.exists) {
                        let appObj = { ...doc.data(), ["id"]: `${doc.id}` };
                        list.push(appObj);
                    }
                });

                list.sort((a, b) => {
                    const aVal = getPackageSortValue(a);
                    const bVal = getPackageSortValue(b);
                    if (aVal === bVal) {
                        const aDate = a.createDate?.seconds ? a.createDate.seconds : 0;
                        const bDate = b.createDate?.seconds ? b.createDate.seconds : 0;
                        return aDate > bDate ? 1 : -1;
                    }
                    return aVal > bVal ? 1 : -1;
                });
                setQuotePackages(list);
                try {
                    sessionStorage.setItem(packagesCacheKey, JSON.stringify({ ts: Date.now(), data: list }));
                } catch (error) {
                    // ignore cache errors
                }
            });

        return () => {
            unsubscribe();
            unsubscribe2();
        };
    }, []);

    // TODO remove the additional logic later Jessica should not have access to this page if display name does not match
    useEffect(() => {
        console.log("QuoteDetailedPage render");
        console.log(currentUserProfile?.isExternal);
        console.log(quote.displayName);
        console.log(currentUserProfile?.displayName);
        console.log(currentUserProfile?.isExternal && quote.displayName == currentUserProfile?.displayName);
        if (!currentUserProfile?.isExternal ? true : (currentUserProfile?.isExternal && quote.displayName == currentUserProfile?.displayName) ? true : false) {
            setIsAuth(true);
        } else if (currentUserProfile?.displayName == "Jessica Dupavillon") {
            // setIsAuth(true);
        }
    }, [currentUserProfile?.isExternal, quote.displayName, currentUserProfile?.displayName]);

    return (
        (isAuth) && <>
            <Grid columns={2}>
                <Grid.Row>
                    <Grid.Column>
                        <ErrorBoundary>
                            <QuoteDetailedStatus
                                quote={quote}
                                quotePackages={quotePackages}
                                // quote_templates={quote_templates}
                                initialValues={quote}
                                lead={lead}
                                profile={currentUserProfile}
                                consultant={consultant}
                                client={client}
                            />
                        </ErrorBoundary>

                        {quote.quote_status === "Draft" && (
                            <ErrorBoundary>
                                <QuoteDetailedManPack quote={quote} profile={currentUserProfile} />
                            </ErrorBoundary>
                        )}
                    </Grid.Column>

                    <Grid.Column>
                        {quote.quote_status === "Draft" && (
                            <ErrorBoundary>
                                <QuoteDetailedLoadHoliday quote={quote} />
                            </ErrorBoundary>
                        )}

                        {quote.quote_status === "Draft" && (
                            <ErrorBoundary>
                                <QuoteDetailedClonePack quote={quote} quotePackages={quotePackages} profile={currentUserProfile} />
                            </ErrorBoundary>
                        )}
                    </Grid.Column>
                </Grid.Row>
            </Grid>

            {quote && quote.id && quotePackages && currentUserProfile && (
                <ErrorBoundary>
                    <QuoteDetailedPackages quote={quote} quotePackages={quotePackages} profile={currentUserProfile} onReorderPackages={reorderPackages} />
                </ErrorBoundary>
            )}

            {/* {quotePackages &&
                quote &&
                profile &&
                consultant &&
                quotePackages.length > 0 &&
                quotePackages.map((quotePackage) => (
                    <QuoteDetailedPackage
                        key={quotePackage.id}
                        quote={quote}
                        quotePackage={quotePackage}
                        form={"quotePackage_" + quotePackage.id}
                        // initialValues={quotePackage}
                        profile={currentUserProfile}
                        consultant={consultant}
                        parentStateSetter={wrapperSetParentState}
                        quotePackages={quotePackages}
                    />
                ))} */}
        </>
    );
}
